/**
 * Shared utility functions for popover plugins (KeyTerm, Footnote, etc.)
 */

/**
 * Extracts text from Slate nodes for display
 */
export function getTextFromNodes(nodes: any[]): string {
  if (!nodes || !Array.isArray(nodes)) return "";
  let text = "";
  nodes.forEach((node) => {
    // Leaf node: text sits directly on the node (new Slate format)
    if (typeof node.text === "string") {
      text += node.text;
    }
    // Element node: recurse into children (new Slate format)
    if (Array.isArray(node.children)) {
      text += getTextFromNodes(node.children);
    }
    // Legacy fallback: old Slate 0.45 leaves/nodes
    if (Array.isArray(node.leaves)) {
      node.leaves.forEach((leaf: any) => {
        if (leaf.text) text += leaf.text;
      });
    }
    if (Array.isArray(node.nodes) && !Array.isArray(node.children)) {
      text += getTextFromNodes(node.nodes);
    }
  });
  return text;
}

/**
 * Capitalizes the first letter of a string
 */
export function capitalize(str: string): string {
  if (!str) return "";
  return str[0]?.toUpperCase() + str.slice(1) || "";
}
